import { useMutation } from 'react-query';
import { AnchorAPI } from 'modules/AnchorAPI';

function useCancelUpload() {
  const { mutate, status } = useMutation(
    ({ requestUuid }: { requestUuid: string }) => {
      return AnchorAPI.cancelUpload({
        requestUuid,
      });
    }
  );

  return {
    cancelUpload: mutate,
    cancelUploadStatus: status,
  };
}

export { useCancelUpload };
